<template>
  <div>
    <div @click="closeAllPopUps" class="message-modal">
      <span :style="{ 'font-weight': '700', 'margin-bottom': '10px' }">
        Message
      </span>
      <div>
        <quillEditor
          class="quill-edit"
          v-model="writePost.desc"
          ref="quillEditor"
          :options="editorOption"
        ></quillEditor>
      </div>

      <div style="margin: 8px"></div>
      <div class="mb-3">
        <div class="tags-input">Tags</div>
        <div>
          <a-select
            show-search
            mode="multiple"
            :value="selectedTags"
            :filter-option="false"
            placeholder="Search for Tags"
            class="w-100 tag-search custom-input"
            @search="handleSelectTags"
            @change="handleSetTags"
          >
            <a-select-option
              v-for="d in searchTage"
              :key="d.id"
              :value="d.name"
            >
              {{ d.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div
        class="feeling-text d-flex align-items-center box"
        v-if="
          (authUser.user.role === 'patient' ||
            authUser.user.role === 'caregiver') &&
          writePost.day_type.length > 0
        "
      >
        <div>
          Feeling
          <span :style="{ 'font-size': '24px' }">{{ getPostEmoji }}</span>
          <b>{{ writePost.day_type }}</b>
        </div>
        <div @click="handleRemoveFeelings" class="cp ml-4">
          <font-awesome-icon
            :style="{
              color: '#FF560D',
            }"
            :icon="['fal', 'times']"
          />
        </div>
      </div>
      <div>
        <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
          <div>
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">
            Loading image...
          </div>
        </div>
        <div :class="fileList.length ? 'd-none' : ''" />
        <!-- Image Upload -->
        <div class="d-flex flex-wrap display-images">
          <div
            class="file-images"
            @click="handleChange(i)"
            v-for="(fi, i) in fileList"
            v-bind:key="i"
          >
            <!-- <img
              :width="500"
              :height="300"
              :style="{ ' object-fit': 'cover', background: 'black' }"
              :src="fi.url"
              alt=""
            /> -->
            <img
              :style="{
                'object-fit': 'contain',
                background: 'black',
                'max-height': '500px',
                'max-width': '600px',
              }"
              :src="fi.url"
              alt=""
            />
            <a-icon class="ico-cancel cp" type="close-circle" theme="filled" />
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="sticky-footer">
      <div class="add-ons">
        <div class="d-flex">
          <div class="add-post">Add to your post</div>
          <div :style="{ width: '67%' }">
            <div>
              <!-- End of Image Upload -->
              <div
                class="button-container"
                :style="{
                  display: 'flex',
                  width: '100%',
                  'justify-content': 'space-between',
                }"
              >
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-end
                    flex-column
                  "
                  ref="emojiPicker"
                >
                  <CustomEmojiPicker
                    :visible="emojiVisible"
                    :handleVisible="handleEmojiVisible"
                    :insert="insert"
                  />Emoji
                </div>
                <div
                  class="
                    d-flex
                    align-items-center
                    flex-column
                    justify-content-end
                    position-relative
                    feeling
                  "
                  v-if="
                    authUser.user.role === 'patient' ||
                    authUser.user.role === 'caregiver'
                  "
                >
                  <font-awesome-icon
                    size="2x"
                    @click="handleCloseFeelings"
                    :style="{
                      color: getPrimaryColor(),
                      transform: 'scale(0.9)',
                    }"
                    :icon="['fal', 'comment-alt-smile']"
                  />Feeling
                  <div class="feeling-popup" v-if="feelingsVisible">
                    <div class="feeling-text">your feeling</div>
                    <div
                      class="feeling-popup--select"
                      @click="handleFeelingChange('good')"
                      :style="{
                        width: '100%',
                        'background-color':
                          writePost.day_type === 'good' ? '#2a71d4' : '',
                      }"
                    >
                      <span class="pop-emoji">😃</span>
                      <span class="pop-text">Good</span>
                    </div>
                    <div
                      class="feeling-popup--select"
                      @click="handleFeelingChange('okay')"
                      :style="{
                        width: '100%',
                        'background-color':
                          writePost.day_type === 'okay' ? '#2a71d4' : '',
                      }"
                    >
                      <span class="pop-emoji">🙂</span
                      ><span class="pop-text">Okay</span>
                    </div>
                    <div
                      class="feeling-popup--select"
                      @click="handleFeelingChange('bad')"
                      :style="{
                        width: '100%',
                        'background-color':
                          writePost.day_type === 'bad' ? '#2a71d4' : '',
                      }"
                    >
                      <span class="pop-emoji">😟</span
                      ><span class="pop-text"> Bad</span>
                    </div>
                    <div
                      class="feeling-popup--select"
                      @click="handleFeelingChange('angry')"
                      :style="{
                        width: '100%',
                        'background-color':
                          writePost.day_type === 'angry' ? '#2a71d4' : '',
                      }"
                    >
                      <span class="pop-emoji">😠</span
                      ><span class="pop-text">Angry</span>
                    </div>
                  </div>
                </div>
                <div
                  class="
                    d-flex
                    align-items-center
                    flex-column
                    position-relative
                    cp
                  "
                >
                  <font-awesome-icon
                    size="2x"
                    :style="{
                      color: getPrimaryColor(),
                      transform: 'scale(0.7)',
                    }"
                    :icon="['fal', 'camera']"
                  />
                  <input
                    class="camera-icon-inp cp"
                    type="file"
                    accept="image/png, image/jpeg, image/gif, image/svg+xml"
                    id="inputFileToLoad"
                    ref="file"
                    @change="handlePicUpload()"
                  />Image
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="post-buttons">
          <button
            key="cancel"
            @click="handleShowModal"
            :style="{
              background: '#fff',
              color: '#000',
              padding: '10px 40px',
              'border-radius': '8px',
              border: '1px solid ' + getPrimaryColor(),
            }"
          >
            Cancel
          </button>
          <a-button
            key="submit"
            type="primary"
            @click="(e) => post(e)"
            class="primary-button ml-4"
            :style="{
              border: '1px solid ' + getPrimaryColor(),
              background: getPrimaryColor(),
              padding: '10px 40px',
              'border-radius': '8px',
            }"
          >
            Post
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import CustomEmojiPicker from "../home/emojiPicker.vue";
import s3Upload from "../../utilities/imageUploader";
import { quillEditor } from "vue-quill-editor";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCamera, faTimes } from "@fortawesome/pro-light-svg-icons";
library.add(faCamera, faTimes);

import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");
const PostRepository = RepositoryFactory.get("posts");
export default {
  name: "CreateMsgModal",
  components: {
    quillEditor,
    CustomEmojiPicker,
  },
  computed: {
    getPostEmoji() {
      if (this.writePost.day_type === "good") {
        return "😃";
      }
      if (this.writePost.day_type === "okay") {
        return "🙂";
      }
      if (this.writePost.day_type === "bad") {
        return "😟";
      }
      if (this.writePost.day_type === "angry") {
        return "😠";
      }
    },
  },
  props: {
    handleShowModal: Function,
    showCongrats: Function,
  },
  data() {
    return {
      isImageUploading: false,
      emojiVisible: false,
      feelingsVisible: false,
      showModal: false,
      writePost: {
        title: "",
        desc: "",
        day_type: "good",
        post_attach: [],
      },
      previewVisible: false,
      previewImage: "",
      fileList: [],
      showPicker: false,
      content: "",
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],

            [{ list: "ordered" }, { list: "bullet" }],

            ["clean"],
          ],
        },
      },
      loc: {
        lat: null,
        lon: null,
      },
      loading: false,
      appliedFilters: "",
      currentPage: 1,
      limit: 10,
      selectedTags: [],
      searchTage: [],
    };
  },

  created() {
    this.handleSelectTags("a");
  },

  methods: {
    fetchPosts(append = false) {
      this.$store.commit("App/setLoading", { data: true });

      PostRepository.getAll(
        this.authUser.user.id,
        this.currentCircle.id,
        this.currentPage,
        this.limit,
        this.appliedFilters,
        this.$store.state.Posts.filterPostKey
      )
        .then((res) => {
          this.$store.commit("Posts/setPosts", res.data);
          this.$store.commit("App/setLoading", { data: false });
          console.log(this.currentPage, "after fetch");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelectTags(value) {
      console.log(value, "search tags");
      PostRepository.getTags(value).then((res) => {
        this.searchTage = res.data.data;
        console.log(this.searchTage, "<- handleSelectTags");
      });
    },
    handleSetTags(value) {
      console.log(value);
      this.selectedTags = value;
    },
    handleFeelingChange(value) {
      this.writePost.day_type = value;
      this.handleCloseFeelings();
    },
    handleRemoveFeelings() {
      this.writePost.day_type = "";
    },
    show() {
      this.showModal = true;
    },
    handleCloseModal() {
      this.showModal = false;

      this.writePost.title = "";
      this.writePost.desc = "";
      this.writePost.day_type = "good";
      this.writePost.post_attach = [];
    },
    insert(emoji) {
      if (this.writePost.desc[this.writePost.desc.length - 2] === "l") {
        this.writePost.desc =
          this.writePost.desc.substring(0, this.writePost.desc.length - 10) +
          emoji +
          this.writePost.desc.substring(this.writePost.desc.length - 10);
      } else {
        this.writePost.desc =
          this.writePost.desc.substring(0, this.writePost.desc.length - 4) +
          emoji +
          this.writePost.desc.substring(this.writePost.desc.length - 4);
      }
      this.handleEmojiVisible();
    },
    post(e) {
      this.handleShowModal();
      this.inProgress = true;
      this.loading = true;

      const payload = {
        user_circle: this.currentCircle.id,
        user: this.authUser.user.id,
        day_type: this.writePost.day_type,
        receiver_user: null,
        post_attach:
          this.writePost.post_attach.length > 0
            ? this.writePost.post_attach
            : null,
        latlong:
          this.loc.lat && this.loc.lon
            ? { lat: this.loc.lat, lon: this.loc.lon }
            : null,
        post_text: this.writePost.desc,
        post_title: this.writePost.title,
        post_time: new Date().toISOString(),
        tags: this.selectedTags,
      };

      if (payload.post_text.length || payload.post_attach.length) {
        PostRepository.createPost(payload)
          .then((res) => {
            this.showWritablePostArea = false;
            this.inProgress = false;
            this.writePost.title = "";
            this.writePost.desc = "";
            this.currentPage = 1;
            this.selectedTags = [];
            this.fetchPosts();
            this.writePost.day_type = "good";
            this.fileList = [];
            this.writePost.post_attach.length = 0;
            this.loading = false;
            this.$notification.success({
              message: "Success",
              description: "Post created successfully.",
            });
            if (!this.authUser.user.first_post) {
              this.showCongrats();
              this.authUser.user.first_post = true;
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.$notification.error({
          message: "Error",
          description: "Provide the required fields to create a new post.",
        });
      }
      this.emojiVisible = false;
      this.feelingsVisible = false;
      this.inProgress = false;
      this.loading = false;
    },
    closeAllPopUps() {
      this.emojiVisible = false;
      this.feelingsVisible = false;
    },

    handleCloseFeelings() {
      this.feelingsVisible = !this.feelingsVisible;
    },
    async handleChange(i) {
      this.fileList.length === 1
        ? (this.fileList = [])
        : this.fileList.splice(i, 1);
      this.writePost.post_attach.splice(i, 1);
    },

    /**
     * Handle image Upload
     */
    async handlePicUpload() {
      if (this.fileList.length) {
        this.$notification.error({
          message: "Error",
          description: "Cannot add more than one image",
        });
      } else {
        this.isImageUploading = true;
        const file = this.$refs.file.files[0];

        try {
          if (file.size > 1024 * 1024 * 5) {
            this.$notification.error({
              message: "Error",
              description: "File size exceeds 5MB limit",
            });
            const input = this.$refs.file;
            input.type = "text";
            input.type = "file";
            this.isImageUploading = false;
          } else if (!file.type.includes("image")){
            this.$notification.error({
              message: "Error",
              description: "Please select only image"
            });
            this.isImageUploading = false;
          } else {
            const urlPayload = { file_name: [file.name] };
            const urlData = await UserRepository.getPresignedUrl(urlPayload);
            const fileName = urlData.data.data.filename[0];
            await s3Upload(urlData.data.data.url[0], file);
            this.writePost.post_attach.push(fileName);
            const fileListData = {
              uid: this.writePost.post_attach.length,
              name: file.name,
              status: "done",
              url: urlData.data.data.preview_url,
            };
            this.isImageUploading = false;
            this.fileList.push(fileListData);
          }
        } catch (err) {
          this.isImageUploading = false;
        }
      }
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 16px;
    font-weight: 500;
  }
}

.create-post-container {
  .post-radio-group {
    .buttn {
      background: pink;
    }

    .ant-radio-button-wrapper {
      border-radius: 18px;
      margin-left: 20px;

      &::before {
        display: none;
      }
    }
  }

  .title-input {
    display: block;
    margin-bottom: 20px;
    border: 1px solid #e2e2e2;
    background: #f7f7f7;
    padding: 10px 30px;

    &:focus {
      box-shadow: 0 0 transparent;
    }
  }

  .message-input-container {
    display: block;
    border: 1px solid #e2e2e2;
    background: #f7f7f7;
    border-radius: 10px;
    padding: 10px 20px;

    textarea {
      border: transparent;
      border-radius: 0;
      border-bottom: 1px solid #e2e2e2;

      &:focus {
        box-shadow: 0 0 transparent;
      }
    }

    .button-container {
      padding: 5px 0 0 0;
      text-align: right;
      display: flex;
      width: 100%;
      align-items: center;
      height: 40px;

      @media screen and (max-width: 900px) {
        justify-content: space-between;
      }
      @media screen and (max-width: 600px) {
        justify-content: space-between;
      }

      input {
        height: 25px;
      }
    }
  }
}

.post-radio-group {
  display: flex;
  .post-radio {
    width: 100px;
    height: 32px;
    text-align: center;
    border-radius: 32px;
    margin-left: 16px;
    @media screen and (max-width: 600px) {
      margin: 15px 10px 15px 0;
      width: 24vw;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.filter-options {
  display: flex;
  justify-content: space-between;

  .filter-by {
    color: #333333;
    font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    &::after {
      content: "";
      margin-left: 0;
    }
  }

  span {
    margin-left: 10px;
    cursor: pointer;
    font-family: Lato;
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 22px;

    &::after {
      color: black;
      content: "|";
      margin-left: 10px;
    }

    &:last-child:after {
      content: "";
      margin-left: 0px;
    }
  }
}

.fa-camera {
  width: 35px;
  height: 35px;
  position: relative;
  vertical-align: text-top;
  cursor: pointer;
}
.camera-icon-inp {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 35px;
  height: 40px;
  cursor: pointer;
}

.wrapper {
  position: relative;
  display: inline-block;
}

.post-card {
  @media screen and (min-width: 800px) {
    padding-right: 40px;
  }
}

.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.flexing {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: auto;
}
.check-box {
  transform: scale(1.3);
  margin-right: 5px;
  cursor: pointer;
}
.file-images {
  display: flex;
  padding: 10px;
  position: relative;
  max-height: 285px;
  .ico-cancel {
    position: absolute;
    font-size: 20px;
    color: red !important;
    top: 0;
    left: 0;
    border-radius: 10px;
    background: #fff;
  }
}
.quill-editor {
  height: 100px !important ;
}
.add-post {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;

  &:first-child {
    @media screen and (max-width: 900px) {
      width: 67%;
    }
  }
}
.ant-modal-footer {
  display: flex;
  justify-content: space-between;
}
.feeling {
  cursor: pointer;
  transition: all 1 ease-in-out;
  &-popup {
    top: absolute;
    position: absolute;
    top: -222px;
    right: 10px;
    border-right: 5px;
    background-color: #ffffff;
    box-shadow: 2px 2px 6px 3px rgba(0, 0, 0, 0.12);
    width: 150px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    padding: 5px;
    margin-left: 5px;

    &--select {
      display: flex;
      padding: 10px;
    }

    &--select:hover {
      width: 100%;
      background-color: #2a71d4;
    }
  }
  .pop {
    &-emoji {
      font-size: 24px;
      line-height: 24px;
      margin-right: 5px;
    }
    &-text {
      font-size: 14px;
      line-height: 24px;
    }
  }
}
.tags-input {
  margin-top: 60px;
  width: 100%;
  font-weight: 700;
  margin-bottom: 5px;
}
.box {
  background: rgba(42, 113, 212, 0.111);
  border-radius: 8px;
  width: fit-content;
}
.display-images {
  max-height: 500px;
  // overflow-y: scroll;
}
.message-modal {
  @media screen and (max-width: 900px) {
    min-height: 70vh;
  }
}
.feeling-text {
  font-size: 16px;
  line-height: 20px;
}
.add-ons {
  @media screen and (max-width: 900px) {
    position: sticky;
    bottom: 0;
    width: 100vw;
    background: #ffffff;
    padding: 10px;
  }
}
.sticky-footer {
  @media screen and (max-width: 900px) {
    // background: aqua;
    position: relative;
    width: 100vw;
    left: calc(-44vw + 43%);
    bottom: 0;
    display: initial;
  }
}
em {
  font-style: italic !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/CreateMessageModal.vue